import { render, staticRenderFns } from "./ScheduleGroups.vue?vue&type=template&id=1d33b364&scoped=true"
import script from "./ScheduleGroups.vue?vue&type=script&lang=js"
export * from "./ScheduleGroups.vue?vue&type=script&lang=js"
import style0 from "./ScheduleGroups.vue?vue&type=style&index=0&id=1d33b364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d33b364",
  null
  
)

export default component.exports